import _ from 'underscore'
import React from 'react'
import moment from 'moment'
import { ChevronDown, ChevronUp } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Label } from '@/components/ui/label'
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import ManagerFilter from '../manager_filter'
import BacklogItemsPartial from './partial'
import store from '../../state/store'

class BacklogItems extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      show_priority: false
    }
  }

  onTogglePriority = () => {
    this.setState({
      show_priority: !this.state.show_priority
    })
  }

  onSwitchView = (value) => {
    store.emit('backlog_items:index', {filter: value})
  }

  onManagerChange = (value) => {
    store.emit('backlog_items:index', {manager_id: value === '' ? 'all' : value})
  }

  onCoordinatorChange = (value) => {
    store.emit('backlog_items:index', {coordinator_id: value === '' ? 'all' : value})
  }

  onItemClick = (item) => {
    store.emit('backlog_items:select', item)
  }

  renderListItem = (item) => {
    const selected = (this.props.selected_item) ?
      `${item.item_id}` === `${this.props.selected_item.item_id}` && `${item.item_type}` === `${this.props.selected_item.item_type}`
      :
      false

    return (
      <BacklogItemsPartial
        key={item.item_id}
        item={item}
        selected={selected}
        onClick={this.onItemClick}
      />
    )
  }

  render() {
    const backlog = this.props.backlog

    const backlog_state = _.first(
      _.select(backlog.states, (item) => {
        return item.value == backlog.filter
      })
    )

    let groups = _.groupBy(backlog.items, function (item) {
      return moment(item.time).calendar(null, {
        sameDay: '[Today]',
        nextDay: '[Tomorrow]',
        nextWeek: 'dddd',
        lastDay: '[Yesterday]',
        lastWeek: '[Last] dddd',
        sameElse: 'ddd, DD MMM YYYY'
      })
    })

    groups = _.pairs(groups)

    const selected_manager = _.find(backlog.manager_options, (m) => `${m.id}` === `${backlog.manager_id}`) || null
    const selected_coordinator = _.find(backlog.coordinator_options, (m) => `${m.id}` === `${backlog.coordinator_id}`) || null
    const special_coordinator = ['any', 'none'].includes(`${backlog.coordinator_id}`) ? `${backlog.coordinator_id}` : null

    return (
      <div className="flex h-full min-h-0 flex-col">
        <div className="scrollbar-dark min-h-0 flex-1 overflow-y-auto px-4 pt-4 pb-10">
          <div className="flex flex-col gap-2">
            <div className="flex min-w-0 flex-col gap-1">
              <div className="flex items-center gap-2">
                <Label className="w-9 shrink-0 text-sm text-muted-foreground">LS</Label>
                <div className="min-w-0 flex-1">
                  <ManagerFilter
                    managers={backlog.manager_options || []}
                    selected={selected_manager}
                    placeholder="-"
                    onChange={this.onManagerChange}
                  />
                </div>
              </div>
              <div className="flex items-center gap-2">
                <Label className="w-9 shrink-0 text-sm text-muted-foreground">SDR</Label>
                <div className="min-w-0 flex-1">
                  <ManagerFilter
                    managers={backlog.coordinator_options || []}
                    selected={selected_coordinator}
                    selected_special={special_coordinator}
                    special_options={[
                      {value: 'any', name: 'Any SDR'},
                      {value: 'none', name: 'No SDR'},
                    ]}
                    placeholder="-"
                    onChange={this.onCoordinatorChange}
                  />
                </div>
              </div>
            </div>
            {((backlog.priority_items?.length || 0) > 0) ?
              <Button variant="outline" size="sm" className="w-full" onClick={this.onTogglePriority}>
                Priority ({backlog.priority_items.length}) {this.state.show_priority ? <ChevronDown className="size-3.5" /> : <ChevronUp className="size-3.5" />}
              </Button>
              : null
            }
            {this.state.show_priority ?
              _.map(backlog.priority_items, (item) => this.renderListItem(item))
              : null
            }
            <Select value={`${backlog.filter}`} onValueChange={this.onSwitchView}>
              <SelectTrigger size="sm" className="w-full">
                <SelectValue>{(backlog_state || {}).name || ''} ({backlog.items.length || 0})</SelectValue>
              </SelectTrigger>
              <SelectContent>
                <SelectGroup>
                  {_.map(backlog.states, (option) => {
                    return (
                      <SelectItem key={`${option.value}`} value={`${option.value}`}>{option.name}</SelectItem>
                    )
                  })}
                </SelectGroup>
              </SelectContent>
            </Select>
          </div>
          {backlog.assignment_required ?
            <p className="px-1 pt-3 text-xs text-muted-foreground">
              Select an LS or SDR to load the backlog.
            </p>
            : null
          }
          {(backlog.items.length > backlog.limit) &&
            <p className="px-1 pt-3 text-xs text-muted-foreground">
              Your backlog is too large. Only the first 200 items will load. If you don't reduce the size of your backlog, you'll miss out on items.
            </p>
          }
          {_.map(groups, (group) => {
            return (
              <div key={group[0]}>
                <div className="px-1 pt-6 pb-1 text-xs font-semibold uppercase tracking-wider text-foreground">{group[0]}</div>
                <div className="flex flex-col gap-2">
                  {_.map(group[1], (item) => {
                    return this.renderListItem(item)
                  })}
                </div>
              </div>
            )
          })}
        </div>
      </div>
    )
  }
}

export default BacklogItems
